import EventBus from '@/event-bus';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _toString from 'lodash/toString';
import _toInteger from 'lodash/toInteger';
import _forEach from 'lodash/forEach';
import Shop from '@/shop';
import createStorage from '@/storage';

const currency = Shop.config.config.currency_code;
const Store = createStorage({ name: 'Products-' + currency });

/**
 * @description
 * Конструктор обработчика пикселя.
 *
 * @return {void}
 */
var VKPixel = function() {
  this.bindEvents();
};

/**
 * @description
 * Прибиваем обработчик события
 *
 * @return {void}
 */
VKPixel.prototype.bindEvents = function() {
  EventBus.subscribe('add_items:insales:cart', this.handleAdd.bind(this));
};

/**
 * @description
 * Обработка события добавления товара
 *
 * @return {void}
 */
VKPixel.prototype.handleAdd = function(eventData) {
  const items = _get(eventData, 'action.items', {});

  _forEach(items, (quantity, itemId) => {
    if (quantity > 0) {
      this.addItem(itemId, eventData.order_lines);
    } else {
      console.warn('Добавляется 0 товаров');
    }
  });

};

/**
 * @description
 * Вызов добавления товара
 *
 * @return {void}
 */
VKPixel.prototype.addItem = function(itemId, order_lines) {
  itemId = _toInteger(itemId);

  var productId = _toString(this.getProductId(itemId, order_lines));

  var priceListId = Shop.config.get('vk').vk.price_list_id;
  var currency = Shop.config.get('currency_code').currency_code;

  Store.getItem(productId)
    .then(function(product) {
      var variant = _find(product.variants, { id: itemId });
      var oldPrice = _get(variant, 'old_price', null);

      oldPrice = (oldPrice < variant.price) ? oldPrice : null;
      var eventParams = {
        products: [
          {
            id: product.id,
            group_id: product.category_id,
            price: variant.price,
            price_old: oldPrice
          }
        ],
        currency_code: currency
      };

      VK.Retargeting.ProductEvent(priceListId, 'add_to_cart', eventParams);
    });
};

VKPixel.prototype.getProductId = function(itemId, order_lines) {
  const foundItem = _find(order_lines, { variant_id: itemId });
  const productId = _get(foundItem, 'product.id');

  return productId;
};

export default VKPixel;
